export default "__VITE_ASSET__CsyFlMrI__"